// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import gql from '@workspace/graphql-codegen-fetch';
import { TagsFragmentDoc } from '../../queries/__generated__/TagsQuery';
export type ToggleMbtcMutationVariables = Exact<{
  mBTC?: boolean | null | undefined;
  uBTC?: boolean | null | undefined;
}>;


export type ToggleMbtcMutation = { featuresToggleMbtc: { isMbtcEnabled: boolean | undefined, features: { __typename: 'Features', id: string, marketingEnabled: boolean | undefined, marketingEnabledSMS: boolean | undefined, marketingEnabledCall: boolean | undefined, videoNotificationsDisabled: boolean | undefined, uBTC: boolean | undefined, mBTC: boolean | undefined, VIP: boolean | undefined, Insider: boolean | undefined, isAmsUser: boolean | undefined, isVip: boolean | undefined, isConfirmedOppositeBetting: boolean | undefined, isLoyaltyDisabled: boolean | undefined, lcToBcCompleted: boolean | undefined } | undefined, errors: Array<{ message: string | undefined, code: number | undefined, params: Array<{ name: string | undefined, value: string | undefined } | undefined> | undefined } | undefined> | undefined } | undefined };


export const ToggleMbtcMutationDocument = gql`
    mutation ToggleMbtcMutation($mBTC: Boolean, $uBTC: Boolean) {
  featuresToggleMbtc(input: { mBTC: $mBTC, uBTC: $uBTC }) {
    isMbtcEnabled
    features {
      id
      ...TagsFragment
    }
    errors {
      message
      code
      params {
        name
        value
      }
    }
  }
}
    ${TagsFragmentDoc}`;